import script from "./SyncBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./SyncBtn.vue?vue&type=script&lang=ts&setup=true"

import "./SyncBtn.vue?vue&type=style&index=0&id=1b0acd58&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b0acd58"]])

export default __exports__